export default __webpack_public_path__ + "static/media/android.98b8eecb.png";